import React from 'react'
import { useTranslation } from 'react-i18next'

import PartnershipsList from './PartnershipsList'
import CreatePartnership from './ParnershipForms/CreatePartnership'
import EditPartnership from './ParnershipForms/EditPartnership'

import useCommonStyles from '../../../styles/common/listPage'

const Partnerships = () => {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  return (
    <>
      <div className={commonClasses.heading}>
        <h3 className={commonClasses.title}>{t('Partnerships')}</h3>
        <p>
          {t(
            'Partnerships are specific partner deals that hold both digital and non-digital rights. Each partnership can be linked to one ad account per platform to deliver digital campaigns.'
          )}
        </p>
        <div className={commonClasses.formButtons}>
          <CreatePartnership />
        </div>
      </div>
      <PartnershipsList />
      <EditPartnership />
    </>
  )
}

export default Partnerships
